import { getTarrifName } from '../helpers';

const TabButton = ({ index, onClick, currentInterval, price_cycle_interval, price_cycle_interval_count }) => {
    const handleClick = () => onClick(index);
    const activeClassName = currentInterval === index ? 'active' : '';
    const name = getTarrifName(price_cycle_interval, price_cycle_interval_count);

    return (
        <div data-name={name} className={`product-price-card-tabs__item ${activeClassName}`} onClick={handleClick}>
            {name}
        </div>
    );
};
export default TabButton;
